export default __webpack_public_path__ + "static/media/monitoring.230acf6a.webp";